import { create } from "zustand";
import axios from "axios";

const userStore = create((set) => ({
  allUser: "",
  isLoading: true,

  fetchAllProductRating: async () => {
    try {
      const res = await axios.get("/site/fetch-all-user-for-product-rating");

      if (res.data.allUser.length) {
        set({ allUser: res.data.allUser });
      }
      set({ isLoading: false });
    } catch (error) {
      console.log(error);
      set({ isLoading: false });
    }
  },
}));

export default userStore;
